module.exports = __webpack_public_path__ + "fonts/righthand-bold-personal.aaecd7c8.ttf";